import { useMemo } from "react";
import { SelectFormGroup } from "../select-form-group/select-form-group";
import { BaseSelectFormGroupProps } from "./base-select-form-group-props";
import { sortStrings } from "@utils/string-util";
import { resources } from "@constants/hardcoded-strings";
import { Company } from "@idw-types/data/reference-data/generic";

type OrganizationSelectFormGroupProps = BaseSelectFormGroupProps & {
    axnCompanies: Array<Company>
};

export const OrganizationSelectFormGroup = (props: OrganizationSelectFormGroupProps) => {
    const { axnCompanies, onChange, selectedOption, idPrefix, disabled, isRequired, isSearchable, isClearable, labelWidth, layout } = props;

    const organizationOptions = useMemo(() => {
        return axnCompanies.filter(company => company.type === "RP")
            .map(company => ({ label: company.name, value: company.id }))
            .sort((a, b) => sortStrings(a.label, b.label));
    }, [axnCompanies]);

    return (
        <SelectFormGroup
            controlId={`${idPrefix}-organization-select`}
            label={resources.common.inputs.organization.label}
            ariaLabel={resources.common.inputs.organization.label}
            automationId={`${idPrefix}-organization-select`}
            onChange={onChange}
            options={organizationOptions}
            selectedOption={selectedOption}
            disabled={disabled}
            isRequired={isRequired}
            isSearchable={isSearchable}
            isClearable={isClearable}
            labelWidth={labelWidth}
            layout={layout}
        />
    );
};